/* eslint-disable no-useless-escape */

import { Helmet } from 'react-helmet-async'

import type { Page } from '@bettermode/common/gql/generated'
import { useRouterPath } from '@tribeplatform/react-sdk'

import { getSeoMetaTags } from './SeoMetaTags.js'
import { validateJsonld } from './utils/meta.utils.js'

interface Props {
  seoTitle: Page['seoDetail']['title']
  seoDescription: Page['seoDetail']['description']
  seoAdditionalMeta: Page['seoDetail']['additionalMeta']
  seoJsonld: Page['seoDetail']['jsonld']
  pageSpaceAddressPath: Page['space']['address']['path']
}

export const PageMeta = ({
  seoTitle,
  seoDescription,
  seoAdditionalMeta,
  seoJsonld,
  pageSpaceAddressPath,
}: Props) => {
  const pathname = useRouterPath()
  const validatedJsonld = validateJsonld(seoJsonld)

  return (
    <Helmet
      bodyAttributes={{
        'data-path': pathname?.replace(/[^\_\-a-zA-Z0-9\/]/g, ''),
        'data-matched-route': `/${pageSpaceAddressPath || ''}`,
      }}
      script={[
        ...(validatedJsonld
          ? [
              {
                type: 'application/ld+json',
                innerHTML: validatedJsonld,
              },
            ]
          : []),
      ]}
    >
      {/* We cannot pass a component to Helmet, hence the function call and the array spread. Read comment in SeoMetaTags.tsx */}
      {...getSeoMetaTags({
        title: seoTitle,
        description: seoDescription,
        additionalMeta: seoAdditionalMeta,
      })}
    </Helmet>
  )
}
